import React from 'react';
import PropTypes from 'prop-types';
import s from './FeaturesCard.module.scss';
import MaterialIcon from '../MaterialIcon/MaterialIcon';

const FeaturesCard = ({ features }) => {
    const items = Array.isArray(features?.items) ? features.items : [];
    return (
        <div className={s.Root}>
            <ul className={s.FeaturesList}>
                {items.map((feature, index) => (
                    <li key={index} className={s.FeatureItem}>
                        <div className={s.Icon}>
                            <MaterialIcon
                                name={feature.icon}
                                className={s.IconImage}
                            />
                        </div>
                        <div className={s.Content}>
                            <h3 className={s.Title}>{feature.title}</h3>
                            <p className={s.Description}>
                                {feature.description}
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

FeaturesCard.propTypes = {};

export default FeaturesCard;
